import { z } from 'zod';
import { CPF_REGEX, BIOMETRIA_EMBEDDING_LENGTHS } from '../constants.js';
export const CreateFuncionarioSchema = z.object({
    empresaId: z.string().min(1),
    secretariaId: z.string().min(1).optional(),
    setorId: z.string().min(1).optional(),
    matricula: z.string().min(1).max(40),
    nome: z.string().min(2).max(180),
    cpf: z.string().regex(CPF_REGEX),
    email: z.string().email().max(180).optional(),
    funcao: z.string().max(120).optional(),
    cargaHorariaSemanal: z.number().int().min(1).max(60).optional(),
    ativo: z.boolean().default(true),
});
export const UpdateFuncionarioSchema = CreateFuncionarioSchema.partial().extend({
    id: z.string().min(1),
});
export const BiometriaUploadSchema = z.object({
    funcionarioId: z.string().min(1),
    embedding: z
        .array(z.number().finite())
        .refine((v) => BIOMETRIA_EMBEDDING_LENGTHS.includes(v.length), `embedding deve ter ${BIOMETRIA_EMBEDDING_LENGTHS.join(' ou ')} dimensoes`),
    tipoModelo: z.string().min(1).max(60), // ex: 'face-api.js'
    versaoModelo: z.string().min(1).max(40),
    qualidadeScore: z.number().min(0).max(1).optional(),
});
// Substitui o conjunto de cercas vinculadas diretamente ao funcionario.
export const UpdateFuncionarioGeofencesSchema = z.object({
    geofenceIds: z.array(z.string().min(1)),
});
//# sourceMappingURL=funcionario.js.map